// ** React Imports
import { useState, useEffect, MouseEvent, useCallback, ReactElement } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'
import { DataGrid, GridEventListener } from '@mui/x-data-grid';
import Typography from '@mui/material/Typography'
import Icon from 'src/features/common/CustomIcon'
import Link from '@mui/material/Link';
// ** Store Imports
import { SelectOption } from 'src/types/common';
import RefreshTwoToneIcon from '@mui/icons-material/RefreshTwoTone';
// ** Custom Components Imports
import Tooltip from '@mui/material/Tooltip'
import { client } from 'src/utils/axios-client'
import { leadEndpoints } from 'src/configs/endpoints'

import _ from 'lodash'
import CardContent from '@mui/material/CardContent'
import Skeleton from '@mui/material/Skeleton'

import { XYPlot, LineSeries, VerticalGridLines, HorizontalGridLines, XAxis, YAxis, VerticalBarSeries, MarkSeries, DiscreteColorLegend, ChartLabel, HeatmapSeries } from 'react-vis';
import { curveCatmullRom } from 'd3-shape';
import Chip from '@mui/material/Chip';
import { ResponsiveHeatMap } from '@nivo/heatmap'


type Props = {
    userId: string
}

type Data = {
    x: string,
    y: number

}

type Point = {
    id: string,
    data: Data[]
    
}



const data = [
    {
        "id": "Walmart",
        "data": [
            {
                "x": "MI",
                "y": 3
            },
            {
                "x": "MQL",
                "y": 2
            },
            {
                "x": "DC",
                "y": 4
            }
        ]
    },
    {
        "id": "British Airways",
        "data": [
            {
                "x": "MI",
                "y": 10
            },
            {
                "x": "MQL",
                "y": 7
            },
            {
                "x": "DC",
                "y": 1
            }
        ]
    },
    
]



const DashboardAccountPenetrationHeatmap = ({ userId }: Props) => {
    const [reloadRecords, setReloadRecords] = useState<boolean>(false)
    const [dataLoaded, setDataLoaded] = useState<boolean>(false)
    const [activityData, setActivityData] = useState<Point[]>([])
    

    useEffect(() => {
        loadRecords(userId);
    }, [reloadRecords, userId])

    const loadRecords = async (userId: string) => {
        const response = await client.get(leadEndpoints.getdashboardaccountpenetration, { params: { userId } });
        setActivityData(response.data.dataValues);
        setDataLoaded(true);

    }

    const BarSeries = VerticalBarSeries;

    const lineGraphSettings = {
        theme: {
            textColor: 'DarkGrey'
        },
    };

    if (dataLoaded) {
        return (
            <Grid container spacing={2} justifyContent={'center'}>
                <Grid item xs={12} md={12} sx={{ display: 'flex', alignItems: 'left', flexDirection: 'column', width: '100%' }} >
                    <Card >
                        <Typography sx={{ fontSize: 16, color: 'DarkGrey', ml: 3, mr: 3, width: '100%' }}>
                            Account Penetration Heatmap
                        </Typography>
                    </Card>
                </Grid>
                <Grid item xs={12} md={12} sx={{ display: 'flex', alignItems: 'left', flexDirection: 'column', width: '100%' }} spacing={1}>
                    <Card sx={{ pt: 4, pb: 3 }}>
                        <Grid item xs={12} md={12} alignItems="flex-start">
                            <div style={{ height: 600 }}>
                                <ResponsiveHeatMap
                                    data={activityData}
                                    theme={lineGraphSettings.theme}
                                    margin={{ top: 60, right: 30, bottom: 60, left: 90 }}
                                    xInnerPadding={0.1}
                                    yInnerPadding={0.03}
                                    valueFormat=">-.2s"
                                    axisTop={{
                                        tickSize: 5,
                                        tickPadding: 5,
                                        tickRotation: -90,
                                        legend: '',
                                        legendOffset: 46
                                    }}
                                    
                                    axisLeft={{
                                        tickSize: 5,
                                        tickPadding: 5,
                                        tickRotation: 0,
                                        legend: 'Account',
                                        legendPosition: 'middle',
                                        legendOffset: -72
                                    }}
                                    colors={{
                                        type: 'diverging',
                                        scheme: 'red_yellow_blue',
                                        divergeAt: 0.5,
                                        minValue: 10,
                                        maxValue: 0
                                    }}
                                    emptyColor="#555555"
                                    legends={[
                                        {
                                            anchor: 'bottom',
                                            translateX: -20,
                                            translateY: 30,
                                            length: 300,
                                            thickness: 8,
                                            direction: 'row',
                                            tickPosition: 'after',
                                            tickSize: 3,
                                            tickSpacing: 4,
                                            tickOverlap: false,
                                            tickFormat: '>-.2s',
                                            title: 'Activities',
                                            titleAlign: 'middle',
                                            titleOffset: 4
                                        }
                                    ]}
                                />
                            </div>
                        </Grid>
                    </Card>
                </Grid>

            </Grid>
        )
    }
    else {
        return <Box>
            <Card variant="outlined">
                <CardContent>
                    <Grid item xs={12} md={12} sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                        <Card >
                            <Skeleton variant="text" sx={{ fontSize: 16, ml: 3, mr: 3 }} width={200} />
                        </Card>
                    </Grid>
                    <Grid container spacing={1} justifyContent={'left'}>
                        <Grid item xs={12} md={12} sx={{ display: 'flex', mb: 0.7, alignItems: 'left' }}>
                            <Skeleton variant="rectangular" width={'100%'} height={300} />
                        </Grid>

                    </Grid>
                </CardContent>

            </Card>

        </Box>
    }

}

export { DashboardAccountPenetrationHeatmap }
export default DashboardAccountPenetrationHeatmap
